import { formatPdpCarat } from './formatPdpCarat';

interface DesktopProductSpecLineInput {
  category: string;
  goldPurity: string | null;
  metal: string;
  metalWeight: number;
  diamondCarat?: number | null;
}

export function formatDesktopProductSpecLine({
  category,
  goldPurity,
  metal,
  metalWeight,
  diamondCarat,
}: DesktopProductSpecLineInput): string {
  const metalPart = [goldPurity, metal].filter(Boolean).join(' ');
  let line = metalPart ? `${category} In ${metalPart}` : category;

  if (metalWeight > 0) {
    line += ` (${metalWeight} gram)`;
  }

  if (diamondCarat) {
    line += ` with Diamonds (${formatPdpCarat(diamondCarat)} Ct)`;
  }

  return line;
}
